import { FC, useState } from 'react';
import { IStudentMessage, SendGBN } from '../../../../models/pushMessage.model';
import { Table, TableColumnsType } from 'antd';
import Button from '../../../Button';
import moment from 'moment';
import useAuth from '../../../../hooks/useAuth';
import config from '../../../../lib/config';
import Pagination from '../../../Pagination';
import { useTranslation } from 'react-i18next';

interface IProps {
  data?: IStudentMessage[];
  showModal(index?: number): void;
}

const StudentMessageTable: FC<IProps> = ({
  data,
  showModal,
}) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();  
  const [page, setPage] = useState(1);

  const getSendGBN = (value: SendGBN) => {
    switch (value) {
      case 'AP':
        return 'PUSH';
      case 'LM':
        return 'LMS';
      case 'ME':
        return 'SMS';
    }
  };

  const columns: TableColumnsType<IStudentMessage> = [
    {
      title: t('student.student.column53'),
      dataIndex: 'sendDate',
      key: 'sendDate',
      width: 150,
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD HH:mm:ss'),
    },
    {
      title: t('student.student.column54'),
      dataIndex: 'sendGBN',
      key: 'sendGBN',
      width: 100,
      align: 'center',
      render: getSendGBN,
    },
    {
      title: t('student.student.column121'),
      dataIndex: 'memberName',
      key: 'memberName',
      width: 100,
      align: 'center',
    },
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: t('student.student.column55'),
      dataIndex: 'content',
      key: 'content',
      render: value => value.length > 40 ? value.slice(0, 40) + '...' : value,
    },
    {
      title: t('student.student.column56'),
      dataIndex: 'pk',
      key: 'pk',
      width: 100,
      align: 'center',
      render: value => (
        <div className='comm-btn__area justify-content-center'>
        <Button
          className="btn-basic small mint"
          onClick={() => showModal(value)}
          text={t('student.student.column56')}
        />
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: config.miniPageSize
        }}
      />
      <div className="comm-bx__between">
        <div />
        <div className="common-paging center">
          <Pagination
            count={data?.length || 0}
            page={page}
            setPage={setPage}
            mini
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={showModal}
            text={t('student.student.button10')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  );
};

export default StudentMessageTable;
